import { render, staticRenderFns } from "./AppDropdownItem.vue?vue&type=template&id=0cae8538&scoped=true&"
import script from "./AppDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./AppDropdownItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae8538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cae8538')) {
      api.createRecord('0cae8538', component.options)
    } else {
      api.reload('0cae8538', component.options)
    }
    module.hot.accept("./AppDropdownItem.vue?vue&type=template&id=0cae8538&scoped=true&", function () {
      api.rerender('0cae8538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/select/AppDropdownItem.vue"
export default component.exports